import style from "./FeaturedBlog.module.css";
import React, {useEffect, useState} from "react";   
import { Link, useNavigate } from 'react-router-dom';
import { useQuery } from "@tanstack/react-query";
import { getBlogsList } from "../../api/containersApi";

export default function FeaturedBlog(){

    const [paginationObject, setPagintaionObject] = useState({
        "limit":21,
        "pageNumber": 1
    });
    
    const { data : blogsList, isLoading, isError } = useQuery({
        queryKey: ["blogsList"],
        queryFn: () => getBlogsList({auth_key: localStorage.getItem("sessionToken"), bodyData: paginationObject }),
    });

    const blogNavigater = useNavigate();
    const handleNavigation = (blogId) => {
        blogNavigater(`/blogs/blog-detail/${blogId}`);
    }

    return(
        <div className={style.FeaturedBlogs_outer}>
            {
                blogsList?.records?.length > 1
                    && 
                <div className={style.FeaturedBlogs_container}>
                    <section className={style.section1} data-aos="fade-right" data-aos-duration="1000">
                        <h1>Featured Post</h1>
                        <div className={style.FeaturedBlogs_card}>
                            <div className={style.imgContainer}>
                                <img src={blogsList?.records[0]?.coverImage} alt="Blog Cover Imge" />
                            </div>
                            <p>{blogsList?.records[0]?.authorName}</p>
                            <p>{blogsList?.records[0]?.blogTitle}</p>
                            <p>{blogsList?.records[0]?.metaDescription}</p>
                            <Link to="/blogs" className={style.readMoreLink}>Read More</Link>
                        </div>
                    </section>
                    <section className={style.section2} data-aos="fade-left" data-aos-duration="1000">
                        <div className={style.section2_heading}>
                            <p>All Posts</p>
                            <Link to="/blogs" className={style.viewAll}>
                                <p className={style.viewAll_p} style={{fontSize: "16px", fontWeight: "400", color: "#FF9900"}}>View all</p>
                            </Link>
                        </div>
                        <div className={style.FeaturedBlogs_list}>
                            {
                                blogsList?.records?.length > 1 
                                    && 
                                blogsList?.records?.slice(1, Math.min(6, blogsList?.records?.length))?.map((blog, index) => {
                                    return(
                                        <div className={style.listItem} key={index} onClick={() => {handleNavigation(blog?.blogId)}}>
                                            <p>By <span style={{color: "#FF9900"}}>{blog?.authorName}</span> | {blog?.createdAt?.split(" at")[0]}</p>
                                            <p>{blog?.blogTitle}</p>
                                        </div>
                                    );
                                })
                            }
                        </div>
                    </section>
                </div>
            }
        </div>
    );
}